<template>
    <div>
        <tb-skeleton v-if="!initialized" :height="100" :theme="'opacity'" :shape="'radius'" bg-color="#dcdbdc"></tb-skeleton>

        <div v-else-if="user">
            <ValidationObserver ref="informationform">
                <form @submit.prevent="saveInformation">
                    <div class="row">
                        <div class="col-xl-10">
                            <div class="row">
                                <label class="col-form-label col-xl-2">Personnummer:</label>
                                <ValidationProvider tag="div" class="col-xl-10" vid="pSecurityNumber" name="Personnummer" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="user.pSecurityNumber" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        <span class="text-muted">YYYYMMDD-XXXX</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row mt-4">
                                <label class="col-form-label col-xl-2">Telefon (privat):</label>
                                <ValidationProvider tag="div" class="col-xl-10" vid="PrivatePhone" name="E-post" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="user.PrivatePhone" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row">
                                <label class="col-form-label col-xl-2">E-post (privat):</label>
                                <ValidationProvider tag="div" class="col-xl-10" vid="bank" name="E-post" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="user.PrivateEmail" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row mt-4">
                                <label class="col-form-label col-xl-2">Adress:</label>
                                <ValidationProvider tag="div" class="col-xl-10" vid="PostalAddress" name="Adress" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="user.PostalAddress" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row">
                                <label class="col-form-label col-xl-2">Postadress:</label>
                                <ValidationProvider tag="div" class="col-xl-3" vid="PostalZip" name="Postnummer" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="user.PostalZip" placeholder="Postnummer" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                                <ValidationProvider tag="div" class="col-xl-7" vid="PostalCity" name="Ort" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="user.PostalCity" placeholder="Ort" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row mt-4">
                                <label class="col-form-label col-xl-2">Bank:</label>
                                <ValidationProvider tag="div" class="col-xl-10" vid="bank" name="Bank" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="user.bank" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row">
                                <label class="col-form-label col-xl-2">Kontonummer (gammalt fält):</label>
                                <div class="col-lg-10">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="user.account" disabled>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <label class="col-form-label col-xl-2">Kontonummer:</label>
                                <ValidationProvider tag="div" class="col-xl-3" vid="BankClearingNo" name="Clearingnummer" rules="" v-slot="{ errors }">
                                    <div class="form-group mb-1">
                                        <input type="text" class="form-control" v-model="user.BankClearingNo" placeholder="Clearingnummer" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                                <ValidationProvider tag="div" class="col-xl-7" vid="BankAccountNo" name="Kontonummer" rules="" v-slot="{ errors }">
                                    <div class="form-group mb-1">
                                        <input type="text" class="form-control" v-model="user.BankAccountNo" placeholder="Kontonummer" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row">
                                <label class="col-form-label col-xl-2"></label>
                                <div class="col-xl-10 text-muted">
                                    <div class="form-group">Ange clearingnummer och kontonummer med endast siffor. (utan bindestreck, punkter och mellanslag)</div>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <label class="col-form-label col-xl-2">Närstående:<div class="text-muted">(Kontakt vid skada)</div></label>
                                <ValidationProvider tag="div" class="col-xl-10" vid="emergencyContact" name="Närstående" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <textarea class="form-control" v-model="user.emergencyContact" v-bind:class="{ 'border-danger':errors[0] }"></textarea>
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row mt-4">
                                <label class="col-form-label col-xl-2">Övrigt:</label>
                                <ValidationProvider tag="div" class="col-xl-10" vid="misc" name="Övrigt" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <textarea class="form-control" v-model="user.misc" v-bind:class="{ 'border-danger':errors[0] }"></textarea>
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                    </div>
                </form>
            </ValidationObserver>

            <div class="d-flex justify-content-end">
                <limitless-button ref="btnsaveinformation" type="button" @click="saveInformation" :busy="busy_saving" icon="icon-floppy-disk">Save</limitless-button>
            </div>
        </div>
        <div v-else-if="not_found">
            <i>Användaren finns inte</i>
        </div>
        <div v-else>
            <i>Något gick fel...</i>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import getError from '@services/ErrorHelper';

export default {
    components: {
        LimitlessButton,
    },
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
    },
    data: () => ({
        initialized: false,
        busy_saving: false,
        not_found: false,
        user: null,
    }),
    mounted() {
        this.getUser();
    },
    methods: {
        getUser() {
            apiClient.get('/vue/users/' + this.id + '')
                .then((response) => {
                    this.user = response.data.user;
                })
                .catch((error) => {
                    const { status } = error.response;
                    if (status === 404) {
                        this.not_found = true;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                });
        },
        async saveInformation() {
            const isValid = await this.$refs.informationform.validate();
            if (isValid) {
                this.busy_saving = true;
                await apiClient.post('/vue/users/' + this.id + '/information', this.user)
                    .then((response) => {
                        this.user = response.data.user;
                        this.$refs.btnsaveinformation.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.informationform.setErrors(parsederror);
                        }
                        this.$refs.btnsaveinformation.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
    },
};

</script>
